import { SelectMenuItem } from "../../ShellCommon/Controls/selectmenu/selectmenu";
import { WindowCommunicationBridgeService } from "../../ShellCommon/eventModule/window-communication-bridge";
import { ScopeWithUserInfo } from "../Startup/sdController";
import { FlightingService, FrameworkFlightingService } from "../sdServices/flightingSvc";
import { ContextService, PresenceDataKey } from "../sdServices/context/context-service";
import { parentStateName } from "../preference/preferenceController";
import { MsalAuthenticationServiceImplementation } from "../../ServiceDesk/sdServices/msal/msal-authentication-service";

export interface EventWithCtrlKey extends ng.IAngularEvent {
  ctrlKey: boolean;
}

export interface NavBarItem {
  id: string;
  uiRef: string;
  label: string;
  enabled: boolean;
  flightName?: string;
  glyph?: string;
  ariaLabel?: string;
}

export class SdNavBarController {
  public presenceItems: SelectMenuItem[];
  public presenceSelected: SelectMenuItem;
  public customItems: SelectMenuItem[] = [];
  public navItems: NavBarItem[];
  private isHeaderLinkActive = false;

  private header: string;
  private userName: string;
  public presenceReady: boolean;
  // @ngInject
  constructor(
    private $scope: ScopeWithUserInfo,
    private windowCommunicationBridgeService: WindowCommunicationBridgeService,
    private $location: ng.ILocationService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private flightingService: FlightingService & FrameworkFlightingService,
    private $window: ng.IWindowService,
    private $state: ng.ui.IStateService,
    private contextService: ContextService
  ) {
    this.presenceItems = [
      { itemName: "Ready for chat", itemValue: "1" },
      { itemName: "Not Available", itemValue: "2" },
      { itemName: "Away", itemValue: "4" }
    ];
    this.presenceSelected = this.presenceItems[1];
    this.customItems = [
      { itemName: "Preferences", itemValue: "preferences" },
      { itemName: "About", itemValue: "about" },
      { itemName: "Logout", itemValue: "logout" }
    ];

    // TODO: This supreme hack of embedding comm console route knowledge in SD's nav bar needs to go away after we rewrite header.
    let isComm = (<any>this.$location).$$path.indexOf("/comm") == -1;
    this.header = isComm ? "Service Desk" : "Communication Console";
    this.isHeaderLinkActive = !isComm;
    this.userName = $scope.userInfo ? $scope.userInfo.idToken.preferred_username : "";
    windowCommunicationBridgeService.subscribe("commStatusChanged", this.commStatusEvent.bind(this), $scope);
    windowCommunicationBridgeService.subscribe("chatApplicationLaunched", this.commReady.bind(this), $scope);
    this.createNavigation();

    this.flightingService.getFlights().then((flights) => {
      $scope.$evalAsync(() => {
        // Enable tab based on flight information.
        // In the future, this will need to be update to take into account access control (ex: only manager can access management)
        angular.forEach(this.navItems, (obj) => {
          if (obj.flightName) {
            obj.enabled = flights.indexOf(obj.flightName) != -1;
          }
        });
      });
    });
  }

  public customItemsClicked(item: SelectMenuItem) {
    switch (item.itemValue) {
      case "logout":
        this.msalAuthenticationService.logout();
        break;
      case "about":
        (<any>$).event.trigger("showAboutDialog", [true]);
        break;
      case "preferences":
        sessionStorage.setItem(parentStateName, this.$state.current.name.toLowerCase());
        this.$window.open("#/settings/", "_blank", "height=768,width=1024,location=no,resizable=yes,scrollbars=yes");
        break;
    }
  }
  public presenceClicked(clicked: SelectMenuItem) {
    if (!this.presenceSelected || this.presenceSelected.itemValue != clicked.itemValue) {
      this.presenceSelected = clicked;
      this.onChangeStatus();
    }
  }
  public commReady(params: any) {
    this.presenceReady = true;
  }
  public checkLink(linkName: string): boolean {
    switch (linkName) {
      case "comm":
        return (<any>this.$location).$$path.indexOf("/comm") != -1;
    }
    return undefined;
  }
  public commStatusEvent(params: any): void {
    if (params && params.status) {
      let foundItem: SelectMenuItem = undefined;
      for (let i = 0; i < this.presenceItems.length; i++) {
        let pItem = this.presenceItems[i];
        if (pItem.itemValue == params.status) {
          foundItem = pItem;
          break;
        }
      }
      if (foundItem && foundItem != this.presenceSelected) {
        this.$scope.$evalAsync(() => {
          this.presenceSelected = foundItem;
        });
      }
    }
  }
  public launchCustomer(): void {
    this.windowCommunicationBridgeService.publish("launchSession", {
      customerType: "consumer",
      customerIdentifier: ""
    });
  }

  public onChangeStatus() {
    if (!this.presenceSelected) {
      return;
    }
    this.contextService.setExtendedContextData(PresenceDataKey, this.presenceSelected.itemName);
    this.windowCommunicationBridgeService.publish("changeCommStatus", {
      state: parseInt(this.presenceSelected.itemValue)
    });
    // this is there to ensure that the selection of the dropdown option item is removed
    $("body").focus();
  }

  private createNavigation() {
    this.navItems = [];
    this.navItems.push({ id: "mytasksTab", label: "My Tasks", uiRef: "mytasks", enabled: false });
    this.navItems.push({ id: "mycasesTab", label: "My Cases", uiRef: "mycases", enabled: false });
    this.navItems.push({ id: "newsTab", label: "News", uiRef: "news", enabled: false });
    this.navItems.push({ id: "trainingsTab", label: "Trainings", uiRef: "trainings", enabled: false });
    this.navItems.push({ id: "myAppointmentsTab", label: "My Appointments", uiRef: "myAppointments", enabled: false });
    this.navItems.push({ id: "myPerformanceTab", label: "My Performance", uiRef: "myPerformance", enabled: false });
    this.navItems.push({ id: "myManagementTab", label: "Management", uiRef: "management", enabled: false });
    this.navItems.push({ id: "resourceTab", label: "Resource", uiRef: "knowledge", enabled: false });
  }
}
